export default "__VITE_ASSET__C1QZQ3Ma__"